import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "enabled_or_value",
})
export class EnabledPipe implements PipeTransform {
  transform(value: boolean | string | null | undefined): string {
    if (value === null || value === undefined) {
      return "Disabled";
    }
    if (typeof value === "boolean") {
      return value ? "Enabled" : "Disabled";
    }
    return value;
  }
}
